(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromDeleteController',MedFrequencyFromDeleteController);

    MedFrequencyFromDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedFrequencyFrom'];

    function MedFrequencyFromDeleteController($uibModalInstance, entity, MedFrequencyFrom) {
        var vm = this;

        vm.medFrequencyFrom = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedFrequencyFrom.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
